'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormat = undefined;

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

exports.normalizeDate = normalizeDate;
exports.isDaySavingLight = isDaySavingLight;
exports.getTimeDifference = getTimeDifference;
exports.getMomentDate = getMomentDate;
exports.formatDate = formatDate;
exports.formatShortDate = formatShortDate;
exports.formatDateTime = formatDateTime;
exports.formatDateToSql = formatDateToSql;
exports.formatDateToUnix = formatDateToUnix;
exports.formatDateTimeToSql = formatDateTimeToSql;
exports.secToMin = secToMin;
exports.secToMinString = secToMinString;
exports.isExpired = isExpired;
exports.todayDate = todayDate;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormat = exports.dateFormat = {
  date: 'DD MMM YYYY',
  dateTime: 'DD MMM YYYY, HH:mm',
  shortDate: 'MM/DD/YY',
  sql: 'YYYY-MM-DD',
  sqlDateTime: 'YYYY-MM-DD HH:mm:00'
};

function normalizeDate(date) {
  var result = date;
  if ((0, _isFinite2.default)(date) && date && date < Date.now() / 100) {
    result = date * 1000;
  }
  return result;
}

function isDaySavingLight() {
  return (0, _moment2.default)().isDST() ? 1 : 0;
}

function getTimeDifference() {
  return (0, _moment2.default)().format('Z');
}

function getMomentDate(dateTime) {
  return (0, _moment2.default)(normalizeDate(dateTime));
}

function formatDate(date) {
  return getMomentDate(date).format(dateFormat.date);
}

function formatShortDate(date) {
  return getMomentDate(date).format(dateFormat.shortDate);
}

function formatDateTime(dateTime) {
  return getMomentDate(dateTime).format(dateFormat.dateTime);
}

function formatDateToSql(date) {
  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var formattedDate = date;
  if ((0, _isFinite2.default)(date) && date && date < Date.now() / 100) {
    formattedDate = new Date(date * 1000);
  }
  return formattedDate ? (0, _moment2.default)(formattedDate).format(withTime ? dateFormat.sqlDateTime : dateFormat.sql) : null;
}

function formatDateToUnix(date) {
  return (0, _moment2.default)(date, 'YYYY-MM-DD').unix();
}

function formatDateTimeToSql(date) {
  return formatDateToSql(date, true);
}

function getDurationTimes(position) {
  var duration = _moment2.default.duration(position, 'seconds');
  var minutes = Math.floor(duration.asMinutes());
  var seconds = ('0' + duration.seconds()).substr(-2);
  return { minutes: minutes, seconds: seconds };
}

function secToMin(position) {
  var _getDurationTimes = getDurationTimes(position),
      minutes = _getDurationTimes.minutes,
      seconds = _getDurationTimes.seconds;

  return minutes + ':' + seconds;
}

function secToMinString(position) {
  var _getDurationTimes2 = getDurationTimes(position),
      minutes = _getDurationTimes2.minutes,
      seconds = _getDurationTimes2.seconds;

  var t = require('i18n-universal').getT();
  return t('{{minutes}} min {{seconds}} sec', { minutes: minutes, seconds: seconds });
}

function isExpired(_ref) {
  var time = _ref.time,
      duration = _ref.duration;

  return Date.now() - time > duration;
}

function todayDate() {
  return formatDate();
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/datetime.js
// module id = 68
// module chunks = 1